const PREFIX = 'web.admin.inspections.templateCustomize.v2';

export const LABEL_KEYS = {
  breadcrumbLibrary: `${PREFIX}.breadcrumbLibrary`,
  breadcrumbEditTemplate: `${PREFIX}.breadcrumbEditTemplate`,
  lastUpdated: `${PREFIX}.lastUpdated`,
  templateSummary: `${PREFIX}.templateSummary`,
  noSections: `${PREFIX}.noSections`,
  noQuestions: `${PREFIX}.noQuestions`,
  sectionCountsInherited: `${PREFIX}.sectionCountsInherited`,
  sectionCountsTemplateOnly: `${PREFIX}.sectionCountsTemplateOnly`,
  sectionCountsLocal: `${PREFIX}.sectionCountsLocal`,
  pointScaleResponseType: `${PREFIX}.pointScaleResponseType`,
  responseTypeName: `${PREFIX}.responseTypeName`,
  lockQuestionTooltip: `${PREFIX}.lockQuestionTooltip`,
  lockSectionTooltip: `${PREFIX}.lockSectionTooltip`,
  hiddenQuestionTooltip: `${PREFIX}.hiddenQuestionTooltip`,
  hideSectionSucceededToast: `${PREFIX}.hideSectionSucceededToast`,
  unhideSectionSucceededToast: `${PREFIX}.unhideSectionSucceededToast`,
  hideQuestionSucceededToast: `${PREFIX}.hideQuestionSucceededToast`,
  unhideQuestionSucceededToast: `${PREFIX}.unhideQuestionSucceededToast`,
  reorderSectionSucceededToast: `${PREFIX}.reorderSectionSucceededToast`,
  reorderQuestionSucceededToast: `${PREFIX}.reorderQuestionSucceededToast`,
  reorderSectionHandleLabel: `${PREFIX}.reorderSectionHandleLabel`,
  reorderQuestionHandleLabel: `${PREFIX}.reorderQuestionHandleLabel`,
  reorderInstructions: `${PREFIX}.reorderInstructions`,
  reorderRoleDescription: `${PREFIX}.reorderRoleDescription`,
  reorderPickedUp: `${PREFIX}.reorderPickedUp`,
  reorderMoved: `${PREFIX}.reorderMoved`,
  reorderDropped: `${PREFIX}.reorderDropped`,
  reorderCancelled: `${PREFIX}.reorderCancelled`,
  operationFailedToast: `${PREFIX}.operationFailedToast`,
  changesNotAppliedToast: `${PREFIX}.changesNotAppliedToast`,
  hideSectionMenuEntry: `${PREFIX}.hideSectionMenuEntry`,
  unhideSectionMenuEntry: `${PREFIX}.unhideSectionMenuEntry`,
  sectionMenuButtonLabel: `${PREFIX}.sectionMenuButtonLabel`,
  hideSectionSpinnerLabel: `${PREFIX}.hideSectionSpinnerLabel`,
  unhideSectionSpinnerLabel: `${PREFIX}.unhideSectionSpinnerLabel`,
  hideSectionFailedMessage: `${PREFIX}.hideSectionFailedMessage`,
  unhideSectionFailedMessage: `${PREFIX}.unhideSectionFailedMessage`,
  retryHideSectionLabel: `${PREFIX}.retryHideSectionLabel`,
  retryUnhideSectionLabel: `${PREFIX}.retryUnhideSectionLabel`,
  blockedSectionInFlightTooltip: `${PREFIX}.blockedSectionInFlightTooltip`,
  hideQuestionMenuEntry: `${PREFIX}.hideQuestionMenuEntry`,
  unhideQuestionMenuEntry: `${PREFIX}.unhideQuestionMenuEntry`,
  questionMenuButtonLabel: `${PREFIX}.questionMenuButtonLabel`,
  hideQuestionSpinnerLabel: `${PREFIX}.hideQuestionSpinnerLabel`,
  unhideQuestionSpinnerLabel: `${PREFIX}.unhideQuestionSpinnerLabel`,
  hideQuestionFailedMessage: `${PREFIX}.hideQuestionFailedMessage`,
  unhideQuestionFailedMessage: `${PREFIX}.unhideQuestionFailedMessage`,
  retryHideQuestionLabel: `${PREFIX}.retryHideQuestionLabel`,
  retryUnhideQuestionLabel: `${PREFIX}.retryUnhideQuestionLabel`,
  blockedInFlightTooltip: `${PREFIX}.blockedInFlightTooltip`,
  blockedStaleTooltip: `${PREFIX}.blockedStaleTooltip`,
  blockedMutationInFlightTooltip: `${PREFIX}.blockedMutationInFlightTooltip`,
  blockedReorderInFlightTooltip: `${PREFIX}.blockedReorderInFlightTooltip`,
  recoveryOutcomeUnknownTitle: `${PREFIX}.recoveryOutcomeUnknownTitle`,
  recoveryOutcomeUnknownBody: `${PREFIX}.recoveryOutcomeUnknownBody`,
  recoveryOutcomeUnknownAction: `${PREFIX}.recoveryOutcomeUnknownAction`,
  recoveryRefreshFailedTitle: `${PREFIX}.recoveryRefreshFailedTitle`,
  recoveryRefreshFailedBody: `${PREFIX}.recoveryRefreshFailedBody`,
  recoveryRefreshFailedAction: `${PREFIX}.recoveryRefreshFailedAction`,
} as const;

export type LabelKey = (typeof LABEL_KEYS)[keyof typeof LABEL_KEYS];

export type Message = {
  key: LabelKey;
  params?: Record<string, string | number>;
};

export type BadgeViewModel = {
  kind: 'lock' | 'hidden';
  tooltipKey: LabelKey;
};
